import UserAuthService from '@Helpers/URLHelpers/UserAuthService';

class FolderProjectViewService {

    constructor(){
        var originalFetch = require('isomorphic-fetch');
        this.fetch = require('fetch-retry')(originalFetch);

        this.FOLDER_PROJECT_VIEW = "/api/folder-project-view";

        this.GET_BY_PARENT_ID_AND_PARENT_TYPE = "/get/{parentId}/{parentType}";
        this.GET_FOLDER_STRUCTURE_BY_USER = '/folder-structure/{parentId}/{parentType}/{userId}';
        this.FOLDER_STRUCTURE = '/folder-structure/{parentId}/{parentType}';
    }

    async getFolderProjectByParentIdAndParentType(parentId, parentType) {
        try {
            let url = window.location.origin + this.FOLDER_PROJECT_VIEW + this.GET_BY_PARENT_ID_AND_PARENT_TYPE;
            url = url
                .replace('{parentId}', parentId)
                .replace('{parentType}', parentType);
            const folderProjectData = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return folderProjectData;
        } catch (err) {
            console.log(err);
        }
    }

    async getFolderStructureByParentIdAndParentType(parentId, parentType) {
        try {
            let url = window.location.origin + this.FOLDER_PROJECT_VIEW + this.FOLDER_STRUCTURE;
            url = url
                .replace('{parentId}', parentId)
                .replace('{parentType}', parentType);
            const folderProjectData = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return folderProjectData;
        } catch (err) {
            console.log(err);
        }
    }

    async getFolderStructureByParentIdAndParentTypeAndUserId(parentId, parentType, userId) {
        try {
            let url = window.location.origin + this.FOLDER_PROJECT_VIEW + this.GET_FOLDER_STRUCTURE_BY_USER;
            url = url
                .replace('{parentId}', parentId)
                .replace('{parentType}', parentType)
                .replace('{userId}', userId);
            const folderProjectData = await this.fetch(url, {
                    method: 'GET',
                    retries: 10,
                    retryDelay: 200
                }).then(data => data.json())
                    .then(data => {
                        if(data.error !== undefined){
                            if(data.error === 'Session Expired') {
                                let userAuthService = new UserAuthService();
                                userAuthService.logout();
                            }
                            else {
                                localStorage.setItem('errorUUID', data.uuid);
                            }
                        }
                        return data;
                    })
            return folderProjectData;
        } catch (err) {
            console.log(err);
        }
    }
}

export default FolderProjectViewService;